import React from 'react'
import MainnetBG from '../../../../assets/bg/pc/bg_mainnet.png'
import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'
// import WhitePaperEng from '../../../../assets/pdf/MCN_Mainnet_Whitepaper_ENG.pdf'
// import WhitePaperKor from '../../../../assets/pdf/MCN_Mainnet_Whitepaper_KOR.pdf'
// import PlanningKor from '../../../../assets/pdf/planning_kor.pdf'
// import PlanningEng from '../../../../assets/pdf/planning_eng.pdf'
// import LightPaperKor from '../../../../assets/pdf/NFTMOA_Light Paper_KOR.pdf'
// import LightPaperEng from '../../../../assets/pdf/NFTMOA_Light Paper_ENG.pdf'
// import IrBookEng from '../../../../assets/pdf/LABSHIGH_IR BOOK_ENG.pdf'
// import IrBookKor from '../../../../assets/pdf/LABSHIGH_IR BOOK_KOR.pdf'
import DownloadBG from '../../../../assets/bg/pc/bg_download.png'
import styled from 'styled-components'

import volume01Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume1_KOR.pdf'
import volume01Eng from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume1_ENG.pdf'

// import volume02KorOld from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR.pdf'
// import volume02Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR_1.0.pdf'
import volume02Kor from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_KOR.pdf'
import volume02Eng from '../../../../assets/pdf/mverse/M_Verse_IR_BOOK_Volume2_ENG.pdf'

import whitepaperKor from '../../../../assets/pdf/mverse/MCN_Mainnet_Whitepaper_KOR.pdf'
import whitepaperEng from '../../../../assets/pdf/mverse/MCN_Mainnet_Whitepaper_ENG.pdf'

import projectKor from '../../../../assets/pdf/mverse/(Official) M_Verse PROJECT PLANNING_KOR.pdf'
import projectEng from '../../../../assets/pdf/mverse/(Official) M_Verse PROJECT PLANNING_ENG.pdf'

const MainnetPCComponent: React.FC = () => {
  return (
    <StyledWrap>
      <Outer>
        <img className={'download_01'} src={DownloadBG} />
        <ServiceList>
          <a className={'item-eng'} download={'M_Verse_IR_BOOK_Volume1_ENG.pdf'} href={volume01Eng} />
          <a className={'item-kor'} download={'M_Verse_IR_BOOK_Volume1_KOR.pdf'} href={volume01Kor} />
        </ServiceList>
        <WhitepaperList>
          <a className='item-eng' download={'M_Verse_IR_BOOK_Volume2_ENG.pdf'} href={volume02Eng} />
          <a className='item-kor' download={'M_Verse_IR_BOOK_Volume2_KOR.pdf'} href={volume02Kor} />
        </WhitepaperList>
        <LigntpaperList>
          <a className='item-eng' download={'MCN_Mainnet_Whitepaper_ENG.pdf'} href={whitepaperEng} />
          <a className='item-kor' download={'MCN_Mainnet_Whitepaper_KOR.pdf'} href={whitepaperKor} />
        </LigntpaperList>
        <PlanningList>
          <a className='item-eng' download={'(Official) M_Verse PROJECT PLANNING_ENG.pdf'} href={projectEng} />
          <a className='item-kor' download={'(Official) M_Verse PROJECT PLANNING_KOR.pdf'} href={projectKor} />
        </PlanningList>
      </Outer>
    </StyledWrap>
  )
}

export default MainnetPCComponent

const StyledWrap = styled(Outer)`
  background: #f5f5f5;
  padding-top: 218px;
  padding-bottom: 360px;

  .download_01 {
    //width: 67%;
    margin: 0 auto;
  }
`

const ServiceList = styled.div`
  position: absolute;
  width: 22%;
  height: 14%;
  top: 30.4%;
  bottom: auto;
  left: 21%;

  & > a {
    position: absolute;
    width: 100%;
    height: 39%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 61%;
  }
`

const WhitepaperList = styled.div`
  position: absolute;
  width: 22%;
  height: 14%;
  top: 30.4%;
  bottom: auto;
  right: 23%;

  & > a {
    position: absolute;
    width: 100%;

    opacity: 0.4;
    height: 39%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 61%;
  }
`

const LigntpaperList = styled.div`
  position: absolute;
  width: 22%;
  height: 14%;
  top: auto;
  bottom: 23%;
  left: 21%;

  & > a {
    position: absolute;
    width: 100%;

    opacity: 0.4;
    height: 39%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 61%;
  }
`

const PlanningList = styled.div`
  position: absolute;
  width: 22%;
  height: 14%;
  top: auto;
  bottom: 23%;
  right: 23%;

  & > a {
    position: absolute;
    width: 100%;
    opacity: 0.4;
    height: 39%;
  }

  .item-eng {
    top: 0;
  }

  .item-kor {
    top: 61%;
  }
`
